import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../context/Authcontext";

const Previewtext = () => {
  const { contextData } = useContext(AuthContext);
  const [text, settext] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // new state variable for error message
  const { id, id2 } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    gettexte();
  }, []);

  const gettexte = async () => {
    let responce;
    try {
      responce = await axios.get(
        `https://pfebackend-zbz0.onrender.com/api/text/${id2}/`
      );
    } catch (error) {
      if (error.response && error.response.status === 500) {
        setErrorMessage(
          "Sorry, there was a problem with the server. Please try again later."
        );
      }
      return;
    }
    settext(responce.data);
  };

  function TextComponent(text) {
    if (text) {
      const paragraphs = text.split("\n");

      const renderedParagraphs = paragraphs.map((paragraph, index) => (
        <p className="textoftext" key={index}>
          {paragraph}
        </p>
      ));

      return <>{renderedParagraphs}</>;
    }
  }

  return (
    <>
      <div className="big-text--container">
        {errorMessage && (
          <div className=" erroremailexiste">{errorMessage}</div>
        )}
        <div className="text--container">
          <p className="">{TextComponent(text.text)}</p>
        </div>
      </div>
    </>
  );
};

export default Previewtext;
